export const getNotificationFormInitialData = () => ({
  viaInApp: true,
  viaPush: true,
  title: "",
  highlights: "",
  imageFile: null,
  scheduleForLater: false,
  scheduledAtDateTime: new Date(),
});
